/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusObjektDetailDto } from '../../models/lexplus-objekt-detail-dto';
import { LexplusUpdateObjektDto } from '../../models/lexplus-update-objekt-dto';

export interface ObjekteControllerUpdateV1$Params {
  id: number;
      body: LexplusUpdateObjektDto
}

export function objekteControllerUpdateV1(http: HttpClient, rootUrl: string, params: ObjekteControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusObjektDetailDto>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusObjektDetailDto>;
    })
  );
}

objekteControllerUpdateV1.PATH = '/v1/objekte/{id}';
